export const SubAbasTeds = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/proaq/teds/${id}/dadosgerais`,
  },
  {
    label: 'Destaques',
    rota: `/daf/proaq/teds/${id}/destaques`,
  },
];

export const SubAbasTedsNovo = [
  {
    label: 'Dados Gerais',
    rota: `/daf/proaq/teds/dadosgerais`,
  },
  // {
  //   label: 'Pautas',
  //   rota: `/daf/proaq/teds/pautas`,
  // },
  // {
  //   label: 'Entregas',
  //   rota: `/daf/proaq/teds/entregas`,
  // },
  {
    label: 'Destaques',
    rota: `/daf/proaq/teds/destaques`,
  },
];
